<template>
<div 
    class="gender-btns-container"
    :class="targetLanguage ? 'target-lang' : ''"
    :style="`width: ${width}; margin-left: ${margin}`"
>
    <button 
        class="gender-item" 
        id="genderM"
        :class="[value === GenderEnum.MALE ? 'selected' : '', targetLanguage ? 'target-lang' : '']"
        @click="handleGenderChange(GenderEnum.MALE)"
        tabindex="4"
    >
        {{targetLanguage ? `${$t('dent_issue_certificate_card_container_customer_gender_man')}(${$t('dent_issue_certificate_card_container_customer_gender_man', targetLanguage)})` : $t('dent_issue_certificate_card_container_customer_gender_man') }}
    </button>
    <button 
        class="gender-item" 
        :class="[value === GenderEnum.FEMALE ? 'selected' : '', targetLanguage ? 'target-lang' : '']"
        @click="handleGenderChange(GenderEnum.FEMALE)"
        tabindex="5"
    >
        {{targetLanguage ? `${$t('dent_issue_certificate_card_container_customer_gender_woman')}(${$t('dent_issue_certificate_card_container_customer_gender_woman', targetLanguage)})` : $t('dent_issue_certificate_card_container_customer_gender_woman') }}
    </button>
    <button 
        class="gender-item"
        :class="[value === '' ? 'selected' : '', targetLanguage ? 'target-lang' : '']"
        @click="handleGenderChange()"
        tabindex="6"
    >
        {{targetLanguage ? `${$t('dent_issue_certificate_card_container_customer_gender_none')}(${$t('dent_issue_certificate_card_container_customer_gender_none', targetLanguage)})` : $t('dent_issue_certificate_card_container_customer_gender_none') }}
    </button>
</div>
</template>
<script>
import { GenderEnum } from '@/enums/common.enums';
export default {
    props: {
        gender: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: false,
            default: '100%',
        },
        margin: {
            type: String,
            required: false,
            default: '0px',
        },
        targetLanguage: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            GenderEnum,
            value: this.gender,
        }
    },
    watch: {
        gender(newValue) {
            this.value = newValue;
        }
    },
    methods: {
        async handleGenderChange(gender) {
            if(!gender) {
                this.value = '';
            } else {
                this.value = gender;
            }
            this.$emit('handleGenderChange', this.value);
        }
    }
}
</script>
<style lang="scss" scoped>
.gender-btns-container {
    width: 100%;
    min-height: 40px; 
    font-size: 15px;
    background-color: #F1F2F3;    
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    gap: 4px;
    flex: 1;
    padding: 4px;
}

.gender-btns-container.target-lang {
    height: auto;
}

.gender-item {
    border-radius: 4px;
    flex: 1;
    border: none;
    height: 30px;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    color: #8d939a;
    background-color: #F1F2F3;
    &:hover {
        cursor: pointer;
    }
}

.target-lang {
    font-size: 13px; 
}

.gender-item:hover {
    background-color: rgba(0,0,0,0.05);
}

.gender-item:active {
    background-color: rgba(0,0,0,0.1);
}

.gender-item.selected,
.gender-item.selected:hover,
.gender-item.selected:active {
    font-weight: bold;
    color: black;
    background-color: white;
}

@media screen and (max-width:1150px) {

    .gender-btns-container {
        font-size: 12px;
    }
}
</style>